<template>
  <div class="company-contain">
    <div v-show="loading" class="page-loading" style="width:100%;height:100%;position:fixed;top:0;;background:#000000;z-index:10000;opacity:0.8; max-width: 640px;">
      <div class="loading-box" style="box-sizing: content-box !important;position: absolute;z-index: 10001;margin: 0px; padding: 0px;top: 50%;left: 50%;text-align: center;transform: translate(-50%, -50%);">
        <div class="loading-img"></div>
      </div>
    </div>

    <!-- main -->
    <div class="search-company-box">      
      <div class="pledge-box1">  
        <div class="Single-list-main">  
          <ul class="Single-list-box">
            <li><p class="date">所属行业</p><p class="time">{{ company.industry | nullVal }}</p></li> 
            <li><p class="date">所属地域</p><p class="time">{{ company.area | nullVal }}</p></li>  
          </ul>   
        </div> 

        <!-- tab -->
        <div class="pledge-box1-top">
          <label class="el-radio" @click.stop.prevent="changeTab(1)"> 
            <span class="el-radio-input" :class="{ 'is-checked': tab==1 }"> 
              <span class="el-radio-inner"></span> 
              <input class="el-radio-original" value="估值比较" type="radio">
            </span> 
            <span class="el-radio-label">估值比较</span> 
          </label>
          <label class="el-radio" @click.stop.prevent="changeTab(2)"> 
            <span class="el-radio-input" :class="{ 'is-checked': tab==2 }"> 
              <span class="el-radio-inner"></span> 
              <input class="el-radio-original" value="成长性比较" type="radio">
            </span> 
            <span class="el-radio-label">成长性比较</span> 
          </label> 
          <label class="el-radio" @click.stop.prevent="changeTab(3)"> 
            <span class="el-radio-input" :class="{ 'is-checked': tab==3 }"> 
              <span class="el-radio-inner"></span> 
              <input class="el-radio-original" value="盈利比较" type="radio">
            </span> 
            <span class="el-radio-label">盈利比较</span> 
          </label> 
          <label class="el-radio" @click.stop.prevent="changeTab(4)"> 
            <span class="el-radio-input" :class="{ 'is-checked': tab==4 }"> 
              <span class="el-radio-inner"></span> 
              <input class="el-radio-original" value="资产比较" type="radio">
            </span> 
            <span class="el-radio-label">资产比较</span> 
          </label> 
          <label class="el-radio" @click.stop.prevent="changeTab(5)"> 
            <span class="el-radio-input" :class="{ 'is-checked': tab==5 }"> 
              <span class="el-radio-inner"></span> 
              <input class="el-radio-original" value="资产比较" type="radio">
            </span> 
            <span class="el-radio-label">现金比较</span> 
          </label> 
        </div><!-- /tab -->


        <!-- 估值比较 -->
        <template v-if="tab == 1">
          <div class="rate-chart"> 
            <div class="echart-wrap">
              <div class="chart-canvas" style="width:100%; height: 200px;"></div>
            </div>
          </div>
          <div class="Single-list-main">
            <template v-for="h in gzbj.dataTable" track-by="$index">  
              <ul class="Single-list-box" :class="{ 'Single-hover': h.name == this.company.shortname}">
                <li><p class="date">排名</p><p class="time">{{ h.rank }}</p></li> 
                <li><p class="date">简称</p><p class="time">{{ h.name }}</p></li> 
                <li><p class="date">市盈率</p><p class="time">{{ h.per | two | money}}</p></li> 
                <li><p class="date">市净率 </p> <p class="time">{{ h.pb | two | money }}</p></li> 
                <li><p class="date">总市值 </p> <p class="time">{{ h.mktcap | two | money }}</p></li> 
                <li><p class="date">流通市值</p> <p class="time">{{ h.nmc | two | money }}</p></li>  
              </ul>  
            </template>
          </div> 
        </template>


        <!-- 成长性比较 -->
        <template v-if="tab == 2">
          <!-- 营业收入增长率 -->
          <div class="rate-chart"> 
            <h3>营业收入增长率(%)</h3>
            <div class="echart-wrap">
              <div class="chart-canvas" style="width:100%; height: 200px;"></div>
            </div>
          </div>

          <!-- 净利润增长率 -->
          <div class="rate-chart"> 
            <h3>净利润增长率(%)</h3>
            <div class="echart-wrap2">
              <div class="chart-canvas2" style="width:100%; height: 200px;"></div>
            </div>
          </div>
          <div class="Single-list-main">
            <template v-for="(index, h) in czxbj.dataTable" track-by="$index">  
              <ul class="Single-list-box" :class="{ 'Single-hover': h.name == this.company.shortname}">
                <li><p class="date">排名</p><p class="time">{{ h.rank }}</p></li> 
                <li><p class="date">代码</p><p class="time">{{ h.code }}</p></li>  
                <li><p class="date">简称</p><p class="time">{{ h.name }}</p></li> 
                <li><p class="date">营业收入增长率(%)</p><p class="time">{{ h.yysrtbzzl | two | money }}</p></li> 
                <li><p class="date">净利润增长率(%)</p><p class="time">{{ h.jlrtbzzl | two | money }}</p></li> 
              </ul>
            </template> 
          </div> 
        </template>


        <!-- 盈利比较 -->
        <template v-if="tab == 3">
          <!-- 净资产收益率 -->
          <div class="rate-chart"> 
            <h3>净资产收益率(%)</h3>
            <div class="echart-wrap">
              <div class="chart-canvas" style="width:100%; height: 200px;"></div>
            </div>
          </div>

          <!-- 每股收益 -->
          <div class="rate-chart"> 
            <h3>每股收益</h3>
            <div class="echart-wrap2">
              <div class="chart-canvas2" style="width:100%; height: 200px;"></div>
            </div>
          </div>

          <div class="Single-list-main">
            <template v-for="(index, h) in ylbj.dataTable" track-by="$index">  
              <ul class="Single-list-box" :class="{'Single-hover': h.name == company.shortname}">
                <li>
                  <p class="date">排名</p> 
                  <p class="time">{{ h.rank }}</p>
                </li> 
                <li>
                  <p class="date">代码</p> 
                  <p class="time">{{ h.name }}</p>
                </li> 
                <li>
                  <p class="date">净资产收益率% </p> 
                  <p class="time">{{ h.jzcsyl | two | money }}</p>
                </li> 
                <li>
                  <p class="date">每股收益</p> 
                  <p class="time">{{ h.basicearningspershare | two | money }}</p>
                </li> 
              </ul>
            </template>     
          </div> 
        </template>

        <!-- 资产比较 -->
        <template v-if="tab == 4">
          <div class="rate-chart">
            <h3>总资产</h3>
            <div class="echart-wrap">
              <div class="chart-canvas" style="width:100%; height: 200px;"></div>
            </div>
          </div>

          <div class="rate-chart">
            <h3>资产负债率(%)</h3>
            <div class="echart-wrap2">
              <div class="chart-canvas2" style="width:100%; height: 200px;"></div>
            </div>
          </div>

          <div class="Single-list-main">
            <template v-for="(index, h) in zcbj.dataTable" track-by="$index">  
              <ul class="Single-list-box" :class="{'Single-hover': h.name == company.shortname}">
                <li><p class="date">排名</p><p class="time">{{ h.rank }}</p></li> 
                <li><p class="date">代码</p><p class="time">{{ h.name }}</p></li> 
                <li><p class="date">总资产</p><p class="time">{{ h.assettotal | two | money }}</p></li> 
                <li><p class="date">资产负债率%</p><p class="time">{{ h.zcfzl | two | money }}</p></li> 
              </ul>
            </template>  
          </div> 
        </template>

         <!-- 现金比较 -->
        <template v-if="tab == 5">
          <div class="rate-chart">
            <h3>经营活动现金金额</h3>
            <div class="echart-wrap">
              <div class="chart-canvas" style="width:100%; height: 200px;"></div>
            </div>
          </div>

          <div class="rate-chart">
            <h3>每股现金流净值</h3>
            <div class="echart-wrap2">
              <div class="chart-canvas2" style="width:100%; height: 200px;"></div>
            </div>
          </div>

          <div class="Single-list-main">
            <template v-for="(index, h) in xjbj.dataTable" track-by="$index">
              <ul class="Single-list-box" :class="{'Single-hover': h.name == company.shortname}">
                <li><p class="date">排名</p> <p class="time">{{ h.rank }}</p></li> 
                <li><p class="date">代码</p> <p class="time">{{ h.name }}</p></li> 
                <li><p class="date">经营活动现金金额</p><p class="time">{{ h.cashoperatingactivites | two | money }}</p></li> 
                <li><p class="date">每股现金流净值</p><p class="time">{{ h.mgjyxjllje | two | money }}</p></li> 
              </ul>
            </template>  
          </div> 
        </template>

      </div>
    </div>
    <!-- /main -->
  </div>

  <!--微信绑定弹框-->
  <div aria-hidden="false" aria-labelledby="myModalLabel" role="dialog" tabindex="-1" id="dialog" class="modal fade in" v-show="tipGoBind">
    <div class="binding-content">
      <a class="binding-logo"></a>
      <div class="binding-text">
        立即绑定IBDATA账号<br/>成为金融分析高手
      </div>
      <div class="binding-bot">
        <a class="binding-no-btn" @click="tipGoBind = false">暂不绑定</a>
        <a class="binding-btn" @click="goBindPage">立即绑定</a>
      </div>
    </div>
  </div>
  <div class="modal-backdrop fade in" v-show="tipGoBind"></div>
  <!-- / 微信绑定弹框-->
</template>

<script>
  import { alert, apiUrl, downloadURL } from '../../helper'
  import $ from 'jquery'
  import userMix from '../../common/userMix'
  import searchMix from '../../common/searchMix'
  import comSearchMix from '../../common/comSearchMix'
  import companyMix from '../../common/companyMix'
  import echartMix from '../../common/echartMix'
  import echarts from 'echarts'
  import wxshareMix from '../../common/wxshareMix'

  export default {
    name: 'FinanceView',
    mixins: [userMix, searchMix, comSearchMix, companyMix, echartMix, wxshareMix],
    data () {
      return {
        originData: [],
        industryList: [],
        page: 1,
        perPage: 10,
        total: 0,
        totalPage: 0,
        beutifulData: '',   // 渲染表格所需数据结构
        beutifulDate: [],   // 渲染表格所需日期
        allDateTyp: [],
        curDateTyp: 'ALL',
        yysr_rows: 0,
        yycb_rows: 0,
        yylr_rows: 0,
        // =============================
        company: {},
        tab: 1,
        financeindustry: [],   // 行业数据
        finance: [],           // 财务数据
        financeDate: [],
        companyname: '',
        gzbj: {      // 估值比较
          data: {},
          dataTable: [],
          sort: '',
          desc: '',
          showChart: '',
        },
        czxbj: {
          // data: {},
          dates: [],
          industry: [],
          my: [],
          dataTable: [],
          sort: '',
          desc: '',
          showChart: '',  //1基本每股收益增长率 2营业收入增长率  3净利润增长率
        },
        ylbj: {
          dates: [],
          industry: [],
          my: [],
          dataTable: [],
          sort: '',
          desc: '',
          showChart: '',
        },
        zcbj: {
          dates: [],
          industry: [],
          my: [],
          dataTable: [],
          sort: '',
          desc: '',
          showChart: '',
        },
        xjbj: {
          // data: {},
          dates: [],
          industry: [],
          my: [],
          dataTable: [],
          sort: '',
          desc: '',
          showChart: '',
        },
      }
    },
    route: {
      data({to}) {

        if (!this.currentuser) {
          this.wxcode = this.getQueryString('code')  // 获取微信登录code
          if (this.wxcode) {
            this.wxlogin(this.wxcode)
          } else {
            this.getProfile(to.query.share)
          }
        }

        if (this.currentuser) { 
          this.queryParam = to.query;
          this.companycode = to.query.companycode;
          this.stype = to.query.stype;

          // 微信签名 分享
          let title = decodeURIComponent(to.query.desc);
          let desc = '你的朋友' + this.currentuser.username + '通过IBDATA给你分享了一份他的独家数据！';
          document.title = title;
          this.getwxsign()    // 微信签名
          this.shareCompany(title, desc);

          this.setSelectedTab();
          this.routerStart();
        }
        
      }
    },
    filters: {
      two: function (value) {
        if (!value) {
          return;
        } else if (value.toString().indexOf('.') >=0) {
          return value.toFixed(2)
        } else {
          return value
        }
      },
    },
    methods: {
      routerStart: function() {
        this.detail();
        this.changeDateType(9);

        this.getFinance();  // 公司财务数据
        this.getAssessmentIndustry('per', 1);  // 估值比较
      },

      // 公司详情 
      detail: function () {
        this.loading = true;
        $.ajax({
          url: apiUrl('/V1.0.0/company/detail'),
          method: 'post',
          async: false,
          dataType: 'json',
          data: JSON.stringify({'code': this.companycode})
        }).done((response) => {

          this.loading = false;
          if (response.status === 0) {
            this.company = response.data;
          } else {
            alert(response.description)
          }

        }).fail((response) => {
          this.loading = false;
          alert('请求失败')
        })
      },

      // 当前公司财务信息
      getFinance: function() {

        this.loading = true;

        let query = {};
        query.code = this.companycode;
        query.uid = parseInt(this.queryParam.uid)
        query.ruid = parseInt(this.queryParam.ruid)
        query.share = this.queryParam.share
        query.plat = this.queryParam.plat
        query.sid = this.queryParam.sid

        $.ajax({
          url: apiUrl('/V1.0.0/company/finance'),
          method: 'post',
          dataType: 'json',
          async: false,
          // data: JSON.stringify({'code': this.companycode})
          data: JSON.stringify(query)
        }).done((response) => {

          if (response.status === 0) {
            this.loading = false;
            if (Object.keys(response.data).length) {

              let sd = this.startdate;
              let ed = this.enddate;
              let resource = response.data;

              for (let key in resource) {
                if (key >= sd && key <= ed) {
                  resource[key]['date'] = key;
                  this.finance.push(resource[key]);
                }
              }

              if (this.finance.length > 0) {
                this.finance.sort((a, b) => {
                  return Date.parse(a.date) - Date.parse(b.date);
                });

                for (let h of this.finance) {
                  this.financeDate.push(h.date);
                }
              }

            }

          } else {
            this.loading = false;
            alert(response.description)
          }
        }).fail((response) => {
          this.loading = false;
          alert('请求失败')
        })
      },

      /**
       * 绘制echart图表
       * @param  { String } typ  tab
       * @param  { String } sort 排序字段
       * @param  { Number } desc 排序方式  升序  降序
       */
      getFinanceIndustry: function(typ, sort, desc) {
        let query = {};
        query.code = this.companycode;
        query.typ = typ;
        query.sort = sort;
        query.desc = parseInt(desc);
        query.uid = parseInt(this.queryParam.uid)
        query.ruid = parseInt(this.queryParam.ruid)
        query.share = this.queryParam.share
        query.plat = this.queryParam.plat
        query.sid = this.queryParam.sid

        this.loading = true;
        $.ajax({
          url: apiUrl('/V1.0.0/company/financeindustry'),
          method: 'post',
          dataType: 'json',
          data: JSON.stringify(query)
        }).done((response) => {

          this.loading = false;

          if (response.status === 0) {

            // 判断ranks中的前五名中是否已经包含了当前公司项
            function isContain(item, arr, shortname) {
              if (!item || !arr || arr.length ==0) { return; }

              for (let h of arr) {
                if (h.code && item.code) {
                  if (h.code == item.code) {
                    return true;
                  }
                } else {
                  if (h.name == shortname) {
                    return true;
                  }
                }
              }

              return false;
            }

            let sd = this.startdate;
            let ed = this.enddate;

            // 成长性比较
            if (typ === 2) {
              this.czxbj.dates = [];
              this.czxbj.industry = [];
              this.czxbj.my = [];
              this.czxbj.dataTable = [];
              this.czxbj.sort = '';
              this.czxbj.desc = '';
              this.czxbj.showChart = '';

              this.czxbj.sort = sort;
              this.czxbj.desc = desc;

              let len = 0;
              let industry_yysr_sum = 0;
              let industry_jlr_sum = 0;
              let row_hyjz = {
                name: '行业均值',
                yysrtbzzl: 0,
                jlrtbzzl: 0,
              };

              let res = response.data.industry;
              res.sort((a, b) => {
                return Date.parse(a.date) - Date.parse(b.date);
              });
              console.log(res);

              // 行业
              for (let h of response.data.industry) {
                if (h.date >= sd && h.date <= ed) {
                  len ++;
                  this.czxbj.dates.push(h.date);
                  this.czxbj.industry.push(h);
                  industry_yysr_sum += h. yysrtbzzl;
                  industry_jlr_sum += h. jlrtbzzl;
                }
              }

              // 排序
              this.czxbj.dates.sort((a, b) => {
                return Date.parse(a) - Date.parse(b);
              });
              this.czxbj.industry.sort((a, b) => {
                return Date.parse(a.date) - Date.parse(b.date);
              });

              if (this.czxbj.dates.length == 0) {
                this.czxbj.dates = this.financeDate;
              }

              row_hyjz. yysrtbzzl = industry_yysr_sum / len;
              row_hyjz. jlrtbzzl = industry_jlr_sum / len;

              // 公司
              for (let h of this.finance) {
                this.czxbj.my.push(h);
              }

              // 表格
              let my = response.data.my;
              let ranks = response.data.ranks;
              my.code = this.company.code;
              my.name = this.company.shortname;

              ranks.unshift(row_hyjz);
              ranks.unshift(my);
              this.czxbj.dataTable = ranks;


              let echart, echart2, timer, timer2, that=this;

              this.$nextTick(function (){
                timer = setInterval(function() {
                  echart = document.querySelector('.chart-canvas');

                  if (echart) {
                    console.log('echart');
                    clearInterval( timer );
                    that.echartCZXBJ('yysrtbzzl');  // 营业收入同比增长率
                  }

                }, 1000);

                timer2 = setInterval(function() {
                  echart2 = document.querySelector('.chart-canvas2');

                  if (echart2) {
                    console.log('echart2')
                    clearInterval( timer2 );
                    that.echartCZXBJ('jlrtbzzl');   // 净利润同比增长率
                  }

                }, 1000);
              });
            }

            // 盈利比较
            if (typ === 3) {
              this.ylbj.dates = [];
              this.ylbj.industry = [];
              this.ylbj.my = [];
              this.ylbj.dataTable = [];
              this.ylbj.sort = '';
              this.ylbj.desc = '';
              this.ylbj.showChart = '';

              this.ylbj.sort = sort;
              this.ylbj.desc = desc;
              this.ylbj.showChart = sort;

              let len = 0;
              let industry_jzcsyl_sum = 0;
              let industry_jbmg_sum = 0;
              let row_hyjz = {
                rank: null,
                name: '行业平均',
                jzcsyl: 0,
                basicearningspershare: 0,
              };

              // 遍历行业数据
              for (let h of response.data.industry) {
                if (h.date >= sd && h.date <= ed) {
                  len ++;
                  this.ylbj.dates.push(h.date);
                  this.ylbj.industry.push(h);
                  industry_jzcsyl_sum += h.jzcsyl;
                  industry_jbmg_sum += h.basicearningspershare;
                }
              }

              // 排序
              this.ylbj.dates.sort((a, b) => {
                return Date.parse(a) - Date.parse(b);
              });
              this.ylbj.industry.sort((a, b) => {
                return Date.parse(a.date) - Date.parse(b.date);
              });

              if (this.ylbj.dates.length == 0) {
                this.ylbj.dates = this.financeDate;
              }

              row_hyjz.jzcsyl = industry_jzcsyl_sum / len;
              row_hyjz.basicearningspershare = industry_jbmg_sum / len;

              // 公司
              for (let h of this.finance) {
                this.ylbj.my.push(h);
              }

              // 表格
              let my = response.data.my;
              let ranks = response.data.ranks;
              if (!isContain(my, ranks, this.company.shortname)) {
                my.code = this.company.code;
                my.name = this.company.shortname; 
                ranks.push(my);
              }

              ranks.sort((a, b) => {
                return a.rank - b.rank
              });
              ranks.push(row_hyjz);
              this.ylbj.dataTable = ranks;


              let echart, echart2, timer, timer2, that = this;

              this.$nextTick(function (){
                
                timer = setInterval(function() {
                  echart = document.querySelector('.chart-canvas');

                  if (echart) {
                    console.log('echart');
                    clearInterval( timer );
                    that.echartYLBJ('jzcsyl');  // 净资产收益率
                  }

                }, 1000);

                timer2 = setInterval(function() {
                  echart2 = document.querySelector('.chart-canvas2');

                  if (echart2) {
                    console.log('echart2')
                    clearInterval( timer2 );
                    that.echartYLBJ('basicearningspershare');   // 每股收益
                  }

                }, 1000);
              });

            }

            // 资产比较
            if (typ === 4) {
              this.zcbj.dates = [];
              this.zcbj.industry = [];
              this.zcbj.my = [];
              this.zcbj.dataTable = [];
              this.zcbj.sort = '';
              this.zcbj.desc = '';
              this.zcbj.showChart = '';

              this.zcbj.sort = sort;
              this.zcbj.desc = desc;
              this.zcbj.showChart = sort;

              let len = 0;
              let industry_assettotal_sum = 0;
              let industry_zcfzl_sum = 0;
              let row_hyjz = {
                rank: null,
                name: '行业平均',
                assettotal : 0,
                zcfzl : 0
              };

              // 遍历行业数据
              for (let h of response.data.industry) {
                if (h.date >= sd && h.date <= ed) {
                  len ++;
                  this.zcbj.dates.push(h.date);
                  this.zcbj.industry.push(h);
                  industry_assettotal_sum += h.assettotal ;
                  industry_zcfzl_sum += h. zcfzl ;
                }
              }

              // 排序
              this.zcbj.dates.sort((a, b) => {
                return Date.parse(a) - Date.parse(b);
              });
              this.zcbj.industry.sort((a, b) => {
                return Date.parse(a.date) - Date.parse(b.date);
              });

              if (this.zcbj.dates.length == 0) {
                this.zcbj.dates = this.financeDate;
              }

              row_hyjz.assettotal  = industry_assettotal_sum / len;
              row_hyjz. zcfzl  = industry_zcfzl_sum / len;

              // 公司
              for (let h of this.finance) {
                this.zcbj.my.push(h);
              }

              // 表格
              let my = response.data.my;
              let ranks = response.data.ranks;
              if (!isContain(my, ranks, this.company.shortname)) {
                my.code = this.company.code;
                my.name = this.company.shortname;
                ranks.push(my);
              }

              // ranks.push(my);
              ranks.sort((a, b) => {
                return a.rank - b.rank
              });
              ranks.push(row_hyjz);
              this.zcbj.dataTable = ranks;

              
              let echart, echart2, timer, timer2, that=this;
              
              this.$nextTick(function (){
                
                timer = setInterval(function() {
                  echart = document.querySelector('.chart-canvas');

                  if (echart) {
                    console.log('echart');
                    clearInterval( timer );
                    that.echartZCBJ('assettotal');  // 总资产
                  }

                }, 1000);

                timer2 = setInterval(function() {
                  echart2 = document.querySelector('.chart-canvas2');

                  if (echart2) {
                    console.log('echart2')
                    clearInterval( timer2 );
                    that.echartZCBJ('zcfzl');   // 资产负债率（%）
                  }

                }, 1000);
              });

            }

            // 现金比较
            if (typ === 5) {
              this.xjbj.dates = [];
              this.xjbj.industry = [];
              this.xjbj.my = [];
              this.xjbj.dataTable = [];
              this.xjbj.sort = '';
              this.xjbj.desc = '';
              this.xjbj.showChart = '';

              this.xjbj.sort = sort;
              this.xjbj.desc = desc;
              this.xjbj.showChart = sort;

              let len = 0;
              let industry_jyhdxjl_sum = 0;
              let industry_jbmgxjl_sum = 0;
              let row_hyjz = {
                rank: null,
                name: '行业平均',
                cashoperatingactivites: 0,
                basicearningspershare: 0
              };

              // 遍历行业数据
              for (let h of response.data.industry) {
                if (h.date >= sd && h.date <= ed) {
                  len ++;
                  this.xjbj.dates.push(h.date);
                  this.xjbj.industry.push(h);
                  industry_jyhdxjl_sum += h.cashoperatingactivites;
                  industry_jbmgxjl_sum += h.basicearningspershare;
                }
              }

              // 排序
              this.xjbj.dates.sort((a, b) => {
                return Date.parse(a) - Date.parse(b);
              });
              this.xjbj.industry.sort((a, b) => {
                return Date.parse(a.date) - Date.parse(b.date);
              });

              if (this.xjbj.dates.length == 0) {
                this.xjbj.dates = this.financeDate;
              }

              row_hyjz.cashoperatingactivites = industry_jyhdxjl_sum / len;
              row_hyjz.mgjyxjllje = industry_jbmgxjl_sum / len;

              // 公司
              for (let h of this.finance) {
                this.xjbj.my.push(h);
              }


              let my = response.data.my;
              let ranks = response.data.ranks;
              if (!isContain(my, ranks, this.company.shortname)) {
                my.code = this.company.code;
                my.name = this.company.shortname;
                ranks.push(my);
              }

              ranks.sort((a, b) => {
                return a.rank - b.rank
              });
              ranks.push(row_hyjz);
              this.xjbj.dataTable = ranks;

              let echart, echart2, timer, timer2, that=this;
            
              this.$nextTick(function (){
                
                timer = setInterval(function() {
                  echart = document.querySelector('.chart-canvas');

                  if (echart) {
                    console.log('echart');
                    clearInterval( timer );
                    that.echartXJBJ('cashoperatingactivites');  // 经营活动现金金额
                  }
                }, 1000);

                timer2 = setInterval(function() {
                  echart2 = document.querySelector('.chart-canvas2');

                  if (echart2) {
                    console.log('echart2')
                    clearInterval( timer2 );
                    that.echartXJBJ('mgjyxjllje');   // 每股现金流净值
                  }
                }, 1000);
              });

            }
          } else {
            alert(response.description)
          }

        }).fail((response) => {
          this.loading = false;
          alert('请求失败');
        })
      },

      /**
       * 估值比较
       * @param  { String } sort 排序字段
       * @param  { Int }    desc 排序方式
       */
      getAssessmentIndustry: function(sort, desc) {
        this.gzbj.data = {};
        this.gzbj.dataTable = [];
        this.gzbj.sort = '';
        this.gzbj.desc = '';

        this.gzbj.sort = sort;
        this.gzbj.showChart = sort;
        this.gzbj.desc = desc;

        let query = {};
        query.code = this.companycode;
        query.sort = sort;
        query.desc = parseInt(desc);
        query.uid = parseInt(this.queryParam.uid)
        query.ruid = parseInt(this.queryParam.ruid)
        query.share = this.queryParam.share
        query.plat = this.queryParam.plat
        query.sid = this.queryParam.sid

        this.loading = true;
        $.ajax({
          url: apiUrl('/V1.0.0/company/assessmentindustry'),
          method: 'post',
          dataType: 'json',
          data: JSON.stringify(query)
        }).done((response) => {

          this.loading = false;
          if (response.status === 0) {
            this.gzbj.data = response.data;

            // 判断ranks中的前五名中是否已经包含了当前公司项
            function isContain(item, arr, shortname) {
              if (!item || !arr || arr.length ==0) { return; }

              if (JSON.stringify(item) == '{}' && shortname) {
                for (let h of arr) {
                  if (h.name == shortname) {
                    return true;
                  }
                }
              }

              for (let h of arr) {
                if (h.code == item.code) {
                  return true;
                }
              }

              return false;
            }


            let my = response.data.my;
            let ranks = response.data.ranks;
            if (!isContain(my, ranks, this.company.shortname)) {
              my.name = this.company.shortname;
              ranks.push(my);
            }

            ranks.sort((a, b)=> {
              return a.rank - b.rank
            });

            let industry = response.data.industry;
            industry.rank = null;
            industry.name = '行业均值';
            ranks.push(industry);

            this.gzbj.dataTable = ranks;
            // console.log(this.gzbj);

            // let that = this;
            // setTimeout(function() {
            //   that.$nextTick(function () {
            //     that.echartGZBJ();
            //   });
            // }, 5000);
            this.$nextTick(function () {
              this.echartGZBJ();
            });
          }

        }).fail((response) => {
          alert('请求失败')
        })
      },

      // 切换tab
      changeTab: function(type) {
        if (!type) { return; }

        this.tab = parseInt(type);

        if (this.tab == 1) {
          this.$nextTick(function() {
            this.getAssessmentIndustry(this.gzbj.sort, this.gzbj.desc)
          });
        } 
        else if (this.tab == 2) {  // 成长性比较
          this.$nextTick(function() {
            this.getFinanceIndustry(2, 'yysrtbzzl', 1);
          });
        } 
        else if (this.tab == 3) {  // 盈利比较
          this.$nextTick(function() {
            this.getFinanceIndustry(3, 'jzcsyl', 1);
          });
        } 
        else if (this.tab == 4) {  // 资产比较
          this.$nextTick(function() {
            this.getFinanceIndustry(4, 'assettotal', 1);
          });
        } 
        else if (this.tab == 5) {  // 现金比较
          this.$nextTick(function() {
            this.getFinanceIndustry(5, 'cashoperatingactivites', 1);
          });
        }
      },

      // ==================================================================== 1-echart - 估值比较
      echartGZBJ: function() {
        $('.chart-canvas').remove();
        $('.echart-wrap').prepend('<div class="chart-canvas" style="height:180px;width:100%;"></div>');

        let img_shuiyin = window.location.origin + '/static/images/analyze_shuiyin2.png';
        let echart = document.querySelector('.chart-canvas');

        if (!echart) {
          console.log('!!');
          return false;
        }

        // 获取数据
        let _legend = ['行业平均值'];
        _legend.unshift(this.company.shortname);

        let data_x = ['市盈率', '市净率'];
        let data_y = [];
        let data_y2 = [];
        data_y.push(this.gzbj.data.my.pb);
        data_y.push(this.gzbj.data.my.per);
        data_y2.push(this.gzbj.data.industry.pb);
        data_y2.push(this.gzbj.data.industry.per);

        var mychart = echarts.init(echart);
        var option = {
          tooltip: {
            trigger: 'axis',
            axisPointer: {
              type: 'cross',
              crossStyle: {
                color: '#999'
              }
            }
          },
          // toolbox: {
          //   feature: {
          //     restore: {show: true},
          //     saveAsImage: {show: true}
          //   }
          // },
          legend: {
            data: _legend
          },
          grid: {
            left: '1%',
            right: '0',
            top: '15%',
            bottom: '0',
            containLabel: true
          },
          xAxis: [
            {
              type: 'category',
              data: data_x,
              axisPointer: {
                type: 'shadow'
              }
            }
          ],
          yAxis: [
            {
              type: 'value',
              // name: '水量',
              // min: 0,
              // max: 250,
              // interval: 50,
              splitNumber: 8,
              axisLabel: {
                formatter: '{value} %'
              }
            }
          ],
          graphic: [
            {
              type: 'image',
              left: 0,       // left right只能有一个生效
              top: 10,
              z: -10,
              bounding: 'raw',
              origin: [75, 75],
              style: {
                image: img_shuiyin,
                width: 350,
                height: 150,
                opacity: 0.4
              }
            }
          ],
          series: [
            {
              name: this.company.shortname,
              type:'bar',
              barMaxWidth: 80,
              data: data_y
            },
            {
              name: '行业平均值',
              type:'bar',
              barMaxWidth: 80,
              data: data_y2
            },
          ]
        };
        mychart.setOption(option);
      },
 
      // ==================================================================== 2-echart - 成长性比较
      echartCZXBJ: function(type) {
        let echart, img_shuiyin, _legend, data_x=[], data_y=[], data_y2=[];

        // 营业收入增长率(%)
        if (type == 'yysrtbzzl') {
          $('.chart-canvas').remove();
          $('.echart-wrap').prepend('<div class="chart-canvas" style="height:180px;width:100%;"></div>');
          echart = document.querySelector('.chart-canvas');
        }

        // 净利润增长率(%)
        if (type == 'jlrtbzzl') {
          $('.chart-canvas2').remove();
          $('.echart-wrap2').prepend('<div class="chart-canvas2" style="height:180px;width:100%;"></div>');
          echart = document.querySelector('.chart-canvas2');
        }

        if (!echart) {
          console.log('!!');
          return false;
        }

        img_shuiyin = window.location.origin + '/static/images/analyze_shuiyin2.png';
        // 获取数据
        _legend = ['行业平均值'];
        _legend.unshift(this.company.shortname);
        data_x = this.czxbj.dates;

        // my
        for (let h of this.czxbj.my) {
          data_y.push(h[type]);
        }
        // industry
        for (let h of this.czxbj.industry) {
          data_y2.push(h[type]);
        }

        function nullVall( param ) {
          if (!param) {
            return '--'
          }

          return param;
        }

        var mychart = echarts.init(echart);
        var option = {
          tooltip: {
            trigger: 'axis',
            axisPointer: {
              type: 'cross',
              crossStyle: {
                color: '#999'
              }
            },
            formatter: function(datas) {   //自定义提示框
              if (datas && datas.length>0) {
                let res = '<ul><li>' + datas[0].axisValue + '<li/>';

                for (let h of datas) {
                  res += "<li style='list-style-type:none;'><span style='display:inline-block;width:9px;height:9px;margin-right:6px;border-radius: 50%;background-color:" + h.color + "'></span>" + h.seriesName + "：" + nullVall( h.value ) + "<li/>";
                }

                res += '</ul>';

                return res;
              }
            }
          },
          // toolbox: {
          //   feature: {
          //     restore: {show: true},
          //     saveAsImage: {show: true}
          //   }
          // },
          legend: {
            data: _legend
          },
          grid: {
            left: '1%',
            right: '0',
            top: '15%',
            bottom: '0',
            containLabel: true
          },
          xAxis: [
            {
              type: 'category',
              data: data_x,
              axisPointer: {
                type: 'shadow'
              }
            }
          ],
          yAxis: [
            {
              type: 'value',
              // name: '水量',
              // min: 0,
              // max: 250,
              // interval: 50,
              splitNumber: 8,
              axisLabel: {
                formatter: '{value} %'
              }
            }
          ],
          graphic: [
            {
              type: 'image',
              left: 0,       // left right只能有一个生效
              top: 10,
              z: -10,
              bounding: 'raw',
              origin: [75, 75],
              style: {
                image: img_shuiyin,
                width: 350,
                height: 150,
                opacity: 0.4
              }
            }
          ],
          series: [
            {
              name: this.company.shortname,
              type:'bar',
              barMaxWidth: 80,
              data: data_y
            },
            {
              name: '行业平均值',
              type:'bar',
              barMaxWidth: 80,
              data: data_y2
            },
          ]
        };

        mychart.setOption(option);
      },

      // ==================================================================== 3-echart - 盈利比较
      echartYLBJ: function(type) {

        let echart, img_shuiyin, _legend, _formatter, data_x=[], data_y=[], data_y2=[];

        // 净资产收益率（%）
        if (type == 'jzcsyl') {
          $('.chart-canvas').remove();
          $('.echart-wrap').prepend('<div class="chart-canvas" style="height:180px;width:100%;"></div>');
          echart = document.querySelector('.chart-canvas');
          _formatter = '{value} %';
        }
        // 每股收益
        if (type == 'basicearningspershare') {
          $('.chart-canvas2').remove();
          $('.echart-wrap2').prepend('<div class="chart-canvas2" style="height:180px;width:100%;"></div>');
          echart = document.querySelector('.chart-canvas2');
          _formatter = '{value}';
        }

        if (!echart) {
          console.log('!!');
          return false;
        }

        _legend = ['行业平均值'];
        // _legend.unshift(this.company.shortname);
        _legend.unshift(this.company.shortname);
        console.log('----------------------------- company: 盈利比较');
        console.log(this.company);
        console.log(this.company.shortname);
        img_shuiyin = window.location.origin + '/static/images/analyze_shuiyin2.png';
        data_x = this.ylbj.dates;

        //my
        for (let h of this.ylbj.my) {
          data_y.push(h[type]);
        }
        //industry
        for (let h of this.ylbj.industry) {
          data_y2.push(h[type]);
        }

        function nullVall( param ) {
          if (!param) {
            return '--'
          }

          return param;
        }

        console.log(_legend);
        var mychart = echarts.init(echart);
        var option = {
          tooltip: {
            trigger: 'axis',
            axisPointer: {
              type: 'cross',
              crossStyle: {
                color: '#999'
              }
            },
            formatter: function(datas) {   //自定义提示框
              if (datas && datas.length>0) {
                let res = '<ul><li>' + datas[0].axisValue + '<li/>';

                for (let h of datas) {
                  res += "<li style='list-style-type:none;'><span style='display:inline-block;width:9px;height:9px;margin-right:6px;border-radius: 50%;background-color:" + h.color + "'></span>" + h.seriesName + "：" + nullVall( h.value ) + "<li/>";
                }

                res += '</ul>';

                return res;
              }
            }
          },
          // toolbox: {
          //   feature: {
          //     restore: {show: true},
          //     saveAsImage: {show: true}
          //   }
          // },
          legend: {
            data: _legend
          },
          grid: {
            left: '1%',
            right: '0',
            top: '15%',
            bottom: '0',
            containLabel: true
          },
          xAxis: [
            {
              type: 'category',
              data: data_x,
              axisPointer: {
                type: 'shadow'
              }
            }
          ],
          yAxis: [
            {
              type: 'value',
              // name: '水量',
              // min: 0,
              // max: 250,
              // interval: 50,
              axisLabel: {
                formatter: _formatter
              }
            }
          ],
          graphic: [
            {
              type: 'image',
              left: 0,       // left right只能有一个生效
              top: 10,
              z: -10,
              bounding: 'raw',
              origin: [75, 75],
              style: {
                image: img_shuiyin,
                width: 350,
                height: 150,
                opacity: 0.4
              }
            }
          ],
          series: [
            {
              name: this.company.shortname,
              type:'bar',
              barMaxWidth: 80,
              data: data_y
            },
            {
              name: '行业平均值',
              type:'bar',
              barMaxWidth: 80,
              data: data_y2
            },
          ]
        };

        mychart.setOption(option);
      },

      // ==================================================================== 4-echart - 资产比较
      echartZCBJ: function(type) {
        
        let echart, img_shuiyin, _legend, _formatter, data_x=[], data_y=[], data_y2=[];

        if (type == 'assettotal') {
          $('.chart-canvas').remove();
          $('.echart-wrap').prepend('<div class="chart-canvas" style="height:180px;width:100%;"></div>');
          echart = document.querySelector('.chart-canvas');
          _formatter = '{value}';
        }
        if (type == 'zcfzl') {
          $('.chart-canvas2').remove();
          $('.echart-wrap2').prepend('<div class="chart-canvas2" style="height:180px;width:100%;"></div>');
          echart = document.querySelector('.chart-canvas2');
          _formatter = '{value} %';
        }

        if (!echart) {
          console.log('!!');
          return false;
        }


        img_shuiyin = window.location.origin + '/static/images/analyze_shuiyin2.png';
        _legend = ['行业平均值'];
        _legend.unshift(this.company.shortname);
        data_x = this.zcbj.dates;

        // my
        for (let h of this.zcbj.my) {
          data_y.push(h[type]);
        }

        // industry
        for (let h of this.zcbj.industry) {
          data_y2.push(h[type]);
        }

        function nullVall( param ) {
          if (!param) {
            return '--'
          }

          return param;
        }

        var mychart = echarts.init(echart);
        var option = {
          tooltip: {
            trigger: 'axis',
            axisPointer: {
              type: 'cross',
              crossStyle: {
                color: '#999'
              }
            },
            formatter: function(datas) {   //自定义提示框
              if (datas && datas.length>0) {
                let res = '<ul><li>' + datas[0].axisValue + '<li/>';

                for (let h of datas) {
                  res += "<li style='list-style-type:none;'><span style='display:inline-block;width:9px;height:9px;margin-right:6px;border-radius: 50%;background-color:" + h.color + "'></span>" + h.seriesName + "：" + nullVall( h.value ) + "<li/>";
                }

                res += '</ul>';

                return res;
              }
            }
          },
          // toolbox: {
          //   feature: {
          //     restore: {show: true},
          //     saveAsImage: {show: true}
          //   }
          // },
          legend: {
            data: _legend
          },
          grid: {
            left: '1%',
            right: '0',
            top: '15%',
            bottom: '0',
            containLabel: true
          },
          xAxis: [
            {
              type: 'category',
              data: data_x,
              axisPointer: {
                type: 'shadow'
              }
            }
          ],
          yAxis: [
            {
              type: 'value',
              // name: '水量',
              // min: 0,
              // max: 250,
              // interval: 50,
              axisLabel: {
                formatter: _formatter
              }
            }
          ],
          graphic: [
            {
              type: 'image',
              left: 0,       // left right只能有一个生效
              top: 10,
              z: -10,
              bounding: 'raw',
              origin: [75, 75],
              style: {
                image: img_shuiyin,
                width: 350,
                height: 150,
                opacity: 0.4
              }
            }
          ],
          series: [
            {
              name: this.company.shortname,
              type:'bar',
              barMaxWidth: 80,
              data: data_y
            },
            {
              name: '行业平均值',
              type:'bar',
              barMaxWidth: 80,
              data: data_y2
            },
          ]
        };

        mychart.setOption(option);
      },

      // ==================================================================== 5-echart - 现金比较
      echartXJBJ: function(type) {

        let echart, img_shuiyin, _legend, data_x=[], data_y=[], data_y2=[];

        // 经营活动现金金额
        if (type == 'cashoperatingactivites') {
          $('.chart-canvas').remove();
          $('.echart-wrap').prepend('<div class="chart-canvas" style="height:180px;width:100%;"></div>');
          echart = document.querySelector('.chart-canvas');
        }
        // 每股现金流净值
        if (type == 'mgjyxjllje') {
          $('.chart-canvas2').remove();
          $('.echart-wrap2').prepend('<div class="chart-canvas2" style="height:180px;width:100%;"></div>');
          echart = document.querySelector('.chart-canvas2');
        }

        if (!echart) {
          console.log('!!');
          return false;
        }

        img_shuiyin = window.location.origin + '/static/images/analyze_shuiyin2.png';
        _legend = ['行业平均值'];
        _legend.unshift(this.company.shortname);
        data_x = this.xjbj.dates;

        // my
        for (let h of this.xjbj.my) {
          data_y.push( h[type] );
        }
        // industry
        for (let h of this.xjbj.industry) {
          data_y2.push( h[type] );
        }  

        function nullVall( param ) {
          if (!param) {
            return '--'
          }

          return param;
        }

        var mychart = echarts.init(echart);
        var option = {
          tooltip: {
            trigger: 'axis',
            axisPointer: {
              type: 'cross',
              crossStyle: {
                color: '#999'
              }
            },
            formatter: function(datas) {   //自定义提示框
              if (datas && datas.length>0) {
                let res = '<ul><li>' + datas[0].axisValue + '<li/>';

                for (let h of datas) {
                  res += "<li style='list-style-type:none;'><span style='display:inline-block;width:9px;height:9px;margin-right:6px;border-radius: 50%;background-color:" + h.color + "'></span>" + h.seriesName + "：" + nullVall(h.value) + "<li/>";
                }

                res += '</ul>';

                return res;
              }
            }
          },
          // toolbox: {
          //   feature: {
          //     restore: {show: true},
          //     saveAsImage: {show: true}
          //   }
          // },
          legend: {
            data: _legend
          },
          grid: {
            left: '1%',
            right: '0',
            top: '15%',
            bottom: '0',
            containLabel: true
          },
          xAxis: [
            {
              type: 'category',
              data: data_x,
              axisPointer: {
                type: 'shadow'
              }
            }
          ],
          yAxis: [
            {
              type: 'value',
              // name: '水量',
              // min: 0,
              // max: 250,
              // interval: 50,
              axisLabel: {
                formatter: '{value}'
              }
            }
          ],
          graphic: [
            {
              type: 'image',
              left: 0,       // left right只能有一个生效
              top: 10,
              z: -10,
              bounding: 'raw',
              origin: [75, 75],
              style: {
                image: img_shuiyin,
                width: 350,
                height: 150,
                opacity: 0.4
              }
            }
          ],
          series: [
            {
              name: this.company.shortname,
              type:'bar',
              barMaxWidth: 80,
              data: data_y
            },
            {
              name: '行业平均值',
              type:'bar',
              barMaxWidth: 80,
              data: data_y2
            },
          ]
        };

        mychart.setOption(option);
      },
    }
  }
</script>

<style scoped>
  /* 加载 */
  .loading-box {
    top: 43% !important;
  }
  .loading-img {
    width: 35px;
    height: 35px;
    background-image: url('../../../static/images/loading2.gif');
    background-size: cover;
  }

  .Quarterly-Report .head-title {
    display: block;
  }

  /*.Single-list-main {
    width: 100%;
    box-shadow: none;
    padding: 0;
  }*/
  .gujia-chart-wrap {
    border: none !important;
  }
</style>


/** WEBPACK FOOTER **
 ** IndustryCompare.vue?24ffa3c6
 **/